if (!window.customElements.get('product-tab-features-video')) {
  window.customElements.define(
    'product-tab-features-video',
    class extends HTMLElement {
      constructor() {
        super();

        this.firstInit();
      }

      firstInit() {
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

          this.setAttribute('loaded', true);
          this.appendChild(content.querySelector('video, model-viewer, iframe'));
        }
      }

      play() {
        this.querySelector('video')?.play();
      }

      stop() {
        const video = this.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      }
    }
  );
}

if (!window.customElements.get('product-tab-features')) {
  window.customElements.define(
    'product-tab-features',
    class extends HTMLElement {
      /** @type {HTMLElement} */
      previousTabButton;
      /** @type {HTMLElement} */
      previousMediaElement;

      constructor() {
        super();
        this.swiperElement = this.querySelector('.swiper');
        this.featuredWrapper = this.querySelector('.product-tab-features__featured-wrapper');
        this.mediaWrapper = this.querySelector('.product-tab-features__media-wrapper');
        this.tabItems = [...this.querySelectorAll('[data-tab-for]')];
        // Set previous
        this.previousTabButton = this.querySelector('[data-tab-for][open]>button');
        console.log(this.previousTabButton)

        this.isMobileMQL = window.matchMedia(`(max-width: 768px)`);
        this.isMobileMQL.addEventListener('change', (event) => {
          if (this.mySwiper) this.destroySwiper();
          if (!event.matches) {
            this.createSwiper();
          }
        });
        if (!this.isMobileMQL.matches) this.createSwiper();
        setTimeout(() => {
          this.firstInit();
        }, 0);
      }

      firstInit() {
        const isMobile = this.isMobileMQL.matches;
        if (isMobile) {
          const video = this.querySelector('[data-tab-for="0"] product-tab-features-video');
          video?.play();
          this.previousMediaElement = video;
        } else {
          const video = this.querySelector('[data-tab-content="0"] product-tab-features-video');
          video?.play();
          this.previousMediaElement = video;
        }
      }

      connectedCallback() {
        this.addEventListener('click', (e) => {
          /** @type {HTMLElement} */
          const button = e.target.closest('[data-tab-for] button');
          if (button) {
            this.handleClickTabButton(button);
          }
        });
      }

      createSwiper() {
        this.mySwiper = new Swiper(this.swiperElement, {
          effect: 'fade',
          slidesPerView: 1,
          // autoHeight: true,
          observer: true,
          resizeObserver: true,
          allowTouchMove: false,
        });
      }

      destroySwiper() {
        this.mySwiper.destroy();
      }

      /**
       * Click tab item
       * @param {HTMLElement} button
       */
      handleClickTabButton(button) {
        if (this.animating) return;

        const isMobile = this.isMobileMQL.matches;
        if (button == this.previousTabButton) return;
        const tab = button.parentElement;
        const previousTab = this.previousTabButton?.parentElement;

        // Active tab item
        this.animating = true;
        this.animateOpenTab(tab);

        // Active content
        const index = Number(tab.getAttribute('data-tab-for'));
        if (isNaN(index)) {
          console.error('<product-tab-features>: slide index is NaN');
          return;
        }
        if (isMobile) {
          const mediaElement = tab.querySelector(`product-tab-features-video`);
          this.previousMediaElement?.stop();
          this.previousMediaElement = mediaElement;
          mediaElement?.play();
        } else {
          this.mySwiper.slideTo(index);
          const mediaElement = this.mediaWrapper.querySelector(`[data-tab-content="${index}"] product-tab-features-video`);
          this.previousMediaElement?.stop();
          this.previousMediaElement = mediaElement;
          mediaElement?.play();
        }
      }

      /**
       * @param {HTMLElement} tab 
       */
      animateOpenTab(tab, duration = 300) {
        const previousTab = this.previousTabButton.parentElement;
        const currentButton = tab.firstElementChild;
        const currentExpandContent = tab.lastElementChild;
        const previousExpandContent = previousTab.lastElementChild;
        tab.setAttribute('opening', '');
        previousTab?.removeAttribute('closing');
        currentExpandContent.style.height = '0px';
        previousExpandContent.style.height = previousExpandContent.firstElementChild.clientHeight + 'px';
        window.requestAnimationFrame(() => {
          currentExpandContent.style.height = currentExpandContent.firstElementChild.clientHeight + 'px';
          previousExpandContent.style.height = '0px';
          previousTab?.removeAttribute('open');
          tab.setAttribute('open', '');
        });
        setTimeout(() => {
          tab?.removeAttribute('opening');
          previousTab.setAttribute('closing', '');
          currentExpandContent.style.height = '';
          previousExpandContent.style.height = '';
          this.previousTabButton = tab.firstElementChild;
          this.animating = false;
        }, duration);
      }
    }
  );
}